import cryptocurrencyTradingContent from "./content/cryptocurrency-trading.json";

export const cryptocurrencyTradingMock = {
  name: "cryptocurrency-trading",
  layoutType: 1,
  areasList: [
    {
      id: "cryptocurrency-trading-1",
      name: "cryptocurrency-trading-content",
      componentName: "Comp:CryptocurrencyTradingPage",
      content: JSON.stringify(cryptocurrencyTradingContent),
    },
  ],
};
